/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Row, Col, Table, OverlayTrigger, Tooltip,Spinner } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

//project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { invoiceDetail, buyerlinkurl,invoicePrintPdf } from 'shared/settings/apiconfig';
import { capitalizeFirstLetter } from 'shared/utils';
import { FEE_TYPE_LIST } from 'shared/settings/config';
// import toast from 'shared/toast';
//style imports
import './InvoiceAllView.scss';

const decimalTypes = ['amountpaid'];

/**
 * this page is used to view invoice
 * 
 * @param props
 * 
 * @param invoiceid
 * 
 * @return html to render invoice view
 * 
**/

export class InvoiceAllView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' }
    constructor(props) {
        super(props);
        this.TransactionType = ["Cash", "Card", "Others"]
        this.paymentType = ["Credit", "Debit"]
        this.approveBack = false
        this.state = {
            isScreenFrom: props?.location?.state?.from,
            DisplayTrackingid: "",
            saleid: '',
            printAllPdf: false,
            invoiceview: 0,
            form: {
                id: this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1),
                billingto: {
                    name: '',
                    addressto1: '',
                    addressto2: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                selectedService: [],
                child_invoice: [],
                trackingid: '',
                items: [],
                total: '',
                buyerspremium: '',
                shippinghandling: '',
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                invoicenumber: '',
                totaltax: '',
                totaltaxamount: '',
                totalbp: '',
                totalbpamount: '',
                totalgrossamount: '',
                totalamount: '',
                invoicemessage: '',
                createddate: '',
                timezone: '',
                additionalamount: ''
            },
            shippedForm: {
                trackingid: '',
                description: '',
                valid: false
            },
            paidForm: {
                transactionType: this.TransactionType[2],
                transactionID: '',
                amountpaid: '',
                description: '',
                paymentType: this.paymentType[0],
                valid: false,
            },
            errors: {
                transactionID: '',
                amountpaid: '',
                description: '',
            },
            windowWidth: window.innerWidth,
            loading: false,
            paidModal: false,
            shippedModal: false,
            isPaidData: false,
            isShippedData: false,
            updateInvoiceData: {
                parentinvoiceid: "",
                invoiceamount: "",
                details: "",
                buyerid: "",
                type: "",
                saleid: ""
            },
            transactionData: [],
            transactionModal: false,
            errorpageredirect: false,
            InvoiceList: this.props.location.state?.invoiceList
        }

    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        // window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);

        let invoiceList = [...this.state.InvoiceList];
        invoiceList.forEach(element => {
            let details = JSON.parse(element['details']);
            let selectedService = [];
            FEE_TYPE_LIST.map((item) => {
                if (details[item.key]) {
                    selectedService.push({
                        ...item,
                        amount: details[item.key],
                        remark: details[item.key + "remark"],
                    });
                }
                return item
            });
            element['selectedService'] = selectedService;
            this.setState({
                saleid: details.saleid
            })
        });

        this.setState({
            "InvoiceList": invoiceList
        })

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }


    /* Get invoice data */
    getInvoiceData = () => {
        this.setState({ loading: true });
        axios.get(getSellerUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    if (response.data.status === 'success') {
                        let data = response.data.data[0];
                        let invoiceData = JSON.parse(response.data.data[0].details);
                        let billingfromCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ' ,' : '';
                        let billingfromCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ' ,' : '';
                        let billingtoCityDelimiter = invoiceData.billingto.city && invoiceData.billingto.state ? ' ,' : '';
                        let billingtoCountryDelimiter = invoiceData.billingto.country && invoiceData.billingfrom.zipcode ? ' ,' : '';
                        this.setState({
                            invoiceview: data.invoiceview,
                            DisplayTrackingid: data.trackshippingid ? data.trackshippingid : '',
                            form: {
                                ...this.state.form,
                                billingto: {
                                    ...this.state.form.billingto,
                                    name: invoiceData.billingto.firstname + ' ' + invoiceData.billingto.lastname,
                                    addressto1: invoiceData.billingto.address1 ? invoiceData.billingto.address1 + ' ,' : '',
                                    addressto2: invoiceData.billingto.address2 ? invoiceData.billingto.address2 + ' ,' : '',
                                    cityState: (invoiceData.billingto.city ? invoiceData.billingto.city : '') + (billingtoCityDelimiter) + (invoiceData.billingto.state ? invoiceData.billingto.state + ' ,' : ''),
                                    countryZipcode: (invoiceData.billingto.country ? invoiceData.billingto.country : '') + (billingtoCountryDelimiter) + (invoiceData.billingto.zipcode ? invoiceData.billingto.zipcode : ''),
                                    email: invoiceData.billingto.contactemail ? invoiceData.billingto.contactemail : invoiceData.billingto.email ? invoiceData.billingto.email : '',
                                    phonenumber: invoiceData.billingto.contactmobile ? invoiceData.billingto.contactmobile : invoiceData.billingto.mobile ? invoiceData.billingto.mobile : '',
                                },
                                billingfrom: {
                                    ...this.state.form.billingfrom,
                                    contactname: invoiceData.billingfrom.contactname ? invoiceData.billingfrom.contactname : '',
                                    address1: invoiceData.billingfrom.address1 ? invoiceData.billingfrom.address1+','+invoiceData.billingfrom.address2  + ' ,' : '',
                                    cityState: (invoiceData.billingfrom.city ? invoiceData.billingfrom.city : '') + (billingfromCityDelimiter) + (invoiceData.billingfrom.state ? invoiceData.billingfrom.state + ' ,' : ''),
                                    countryZipcode: (invoiceData.billingfrom.country ? invoiceData.billingfrom.country : '') + (billingfromCountryDelimiter) + (invoiceData.billingfrom.zipcode ? invoiceData.billingfrom.zipcode : ''),
                                    contactemail: invoiceData.billingfrom.contactemail ? invoiceData.billingfrom.contactemail : invoiceData.billingfrom.email ? invoiceData.billingfrom.email : '',
                                    contactmobile: invoiceData.billingfrom.contactmobile ? invoiceData.billingfrom.contactmobile : invoiceData.billingfrom.mobile ? invoiceData.billingfrom.mobile : '',
                                },
                                trackingid: data.trackshippingid ? data.trackshippingid : '',
                                shippinghandling: invoiceData.shippinghandling,
                                items: invoiceData.items,
                                status: data.invoicestatus,
                                invoiceamount: data.invoiceamount,
                                pendingamount: data.pendingamount,
                                invoicenumber: data.invoicenumber,
                                invoicemessage: invoiceData.invoicemessage ? JSON.parse(invoiceData.invoicemessage).content.body : '',
                                createddate: data.createddate ? data.createddate : '',
                                timezone: data.timezonename ? data.timezonename : '',
                                additionalamount: invoiceData.additionalamount ? invoiceData.additionalamount : ''
                            },
                            paidForm: {
                                ...this.state.paidForm,
                                trackshippingid: data.trackshippingid != null ? data.trackshippingid : ""
                            },
                            shippedForm: {
                                trackingid: data.trackshippingid != null ? data.trackshippingid : "",
                                description: "shippingnotes" in data && data.shippingnotes != null ? data.shippingnotes : "",
                                valid: false
                            },
                            additionalnotes: data.additionalnotes ? data.additionalnotes : '',
                            loading: false,
                            isShippedData: data.trackshippingid != null ? true : false,
                            updateInvoiceData: {
                                ...this.state.updateInvoiceData,
                                parentinvoiceid: data.id != null ? data.id : "",
                                invoiceamount: data.invoiceamount != null ? data.invoiceamount : "",
                                details: data.details != null ? data.details : "",
                                buyerid: data.buyerid != null ? data.buyerid : "",
                                type: data.type != null ? data.type : "",
                                saleid: data.saleid != null ? data.saleid : ""
                            }

                        }, () => {
                            this.calculateTotal();
                        });
                    }
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    errorpageredirect: true,
                    // invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }
    printPdf = () => {
        this.setState({ printAllPdf: true });
        let invoiceId = this.state.InvoiceList.map(x => x.id)
        let selectedPrint = this.props.location.state?.state?.selectedPrint
        let config = getSellerHeaders();
        config['responseType'] = 'blob';
        const data = {
            "invoiceid": selectedPrint ? invoiceId : [],
            "type": selectedPrint ? "print" : "printall",
            "saleid": this.state.saleid,
        }
        axios.post(getSellerUrl(invoicePrintPdf), JSON.stringify({ data }), config).then((response) => {
        // axios.get(getSellerUrl(`${invoicePrintAll}/${Number(this.state.saleid)}`), config)
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);
            window.open(fileURL, '_blank');
            this.setState({ printAllPdf: false });
        })
    }


    navigateToList = () => {
        const state = this.props.location.state;
        if (!state) {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
        if (this.props?.location?.state?.name === "Saledashboard") {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: state })
        }
        if (state?.name === "Invoice") {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
    };

    render() {
        return (
            <div  id="invoiceviewallscreen">
                {
                    <div className="invoiceView container " style={{ marginTop: '10px',width: '85%', marginBottom: '10px' }}>
                        <div className="no-print">
                                <Button style={{ backgroundColor: '#A50050' }} onClick={() => { this.navigateToList() }}><i className="fa fa-chevron-left" ></i>Back</Button>
                                <Button style={{ float: 'right' }} className="btn-dark" onClick={() => this.printPdf()}>Print All {this.state.printAllPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                        </div>
                    </div>
                }
                {this.state.InvoiceList.map((item, index) => {
                    let detail = JSON.parse(item['details']);
                    let invoiceview = item['invoiceview']
                    let itemcount = detail?.items.length
                    let invoicemessage = detail.invoicemessage ? JSON.parse(detail.invoicemessage).content.body : ''
                    let amountTotal = 0;
                    let taxTotal = 0;
                    let taxamountTotal = 0;
                    let buyerspremiumTotal = 0;
                    let buyerspremiumamountTotal = 0;
                    let taxonbuyerspremiumTotal = 0;
                    let applytaxonbp = detail.applytaxonbp;
                    let grossamountTotal = 0;
                    let selectedServeice = item.selectedService ?  item.selectedService : [] 
                    detail.items.forEach(item => {
                        amountTotal = amountTotal + parseFloat(item.amount);
                        taxTotal = taxTotal + parseFloat(item.tax);
                        taxamountTotal = taxamountTotal + (item.taxamount ? item.taxamount : 0);
                        buyerspremiumTotal = buyerspremiumTotal + parseFloat(item.buyerspremium);
                        buyerspremiumamountTotal = buyerspremiumamountTotal + parseFloat(item.buyerspremiumamount);
                        taxonbuyerspremiumTotal = taxonbuyerspremiumTotal + parseFloat(item.taxonBPamount);
                        grossamountTotal = grossamountTotal + parseFloat(item.grossamount);
                    });
                    return (
                        <div className={`invoiceView container `} style={{ width: this.state.windowWidth > 425 ? '85%' : '100%' }} id={index}>
                            <div className="invoiceBorder">
                                <div className={` ${index != 0 && index != this.state.InvoiceList.length ? "pagebreak" : ""}`}>
                                    <div className={`d-flex ${this.state.windowWidth > 800 ? "flex-row" : ""}   border-bottom ${this.state.windowWidth > 800 ? '' : 'row'}`}>
                                        <div className={`  ${this.state.windowWidth > 800 ? 'justify-content-left text-left w-50' : 'justify-content-center text-center'} col-md-6 col-xs-12`}>
                                            <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" height="60px" width="170px" />
                                            {<span className={`${item.invoicestatus.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                <i className={`fa ${this.status[item.invoicestatus.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{item.invoicestatus.toUpperCase()}</span>}
                                        </div>
                                        <div className={`${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'}  col-md-6`}>
                                            <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px" }}>Invoice: {item.invoicenumber}</div></div>
                                            {item.trackshippingid ?
                                                <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px" }}>Tracking Id: {item.trackshippingid ? item.trackshippingid : "  $ 0.00"}</div></div> : ""
                                            }
                                            {item.invoiceitemreceiptmethod && invoiceview ?
                                                <span className="h4">Item Receipt Method: {item.invoiceitemreceiptmethod ? capitalizeFirstLetter(item.invoiceitemreceiptmethod) : "  $ 0.00"}</span>:"" 
                                            }
                                        </div>
                                    </div>
                                    <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4 border-bottom mx-0`}>
                                        <div className="col col-md-4 col-xs-12 padding">
                                            <p style={{ wordBreak: "break-word" }}><b className="text-secondary"> Billing To </b></p>
                                            <p style={{ wordBreak: "break-word" }}><b>{detail['billingto']['firstname']} {detail['billingto']['lastname']}</b></p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingto']['address1'] ? `${detail['billingto']['address1']}, ` : ""}{detail['billingto']['address2'] ? `${detail['billingto']['address2']},` : ""}</p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingto']['city'] ? `${detail['billingto']['city']}, ` : ""}{detail['billingto']['state'] ? `${detail['billingto']['state']}` : ""}</p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingto']['country'] ? `${detail['billingto']['country']}, ` : ""}{detail['billingto']['zipcode'] ? `${detail['billingto']['zipcode']}` : "" }</p>
                                            <p style={{ color: "#1d9aa5", wordBreak: 'break-word' }}>{detail['billingto']['email']}</p>
                                            <p style={{ color: "#1d9aa5" }}>{detail['billingto']['mobile'] ? `Phone no: ${detail['billingto']['mobile']}` : ""}</p>
                                        </div>
                                        <div className="col col-md-4 col-xs-12 padding">
                                            <p><b className="text-secondary">Pickup Location</b></p>
                                            <p style={{ wordBreak: "break-word" }}><b>{detail['billingfrom']['contactname']}</b></p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingfrom']['address1'] ? `${detail['billingfrom']['address1']}, ` : ""}{detail['billingfrom']['address2'] ? `${detail['billingfrom']['address2']},` : ""}</p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingfrom']['city'] ? `${detail['billingfrom']['city']}, ` : ""}{detail['billingfrom']['state'] ? `${detail['billingfrom']['state']}` : ""}</p>
                                            <p style={{ wordBreak: "break-word" }}>{detail['billingfrom']['country'] ? `${detail['billingfrom']['country']}, ` : ""}{detail['billingfrom']['zipcode'] ? `${detail['billingfrom']['zipcode']}` : "" }</p>
                                            <p style={{ color: "#1d9aa5" }}>{detail['billingfrom']['contactemail']}</p>
                                            <p style={{ color: "#1d9aa5" }}>{detail['billingfrom']['contactmobile'] ? `Phone no: ${detail['billingfrom']['contactmobile']}` : ""}</p>
                                        </div>
                                        <div className="col col-md-4 col-xs-12 padding">
                                            <p><b className="text-secondary">Invoice Date</b></p>
                                            <p><b>{moment.utc(item.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                           {detail['shippingto'] ? <div>
                                                <p><b className="text-secondary">Shipping to</b></p>
                                                <p style={{ wordBreak: "break-word" }}>{detail['shippingto']['address1'] ? `${detail['shippingto']['address1']}, ` : ""}</p>
                                                <p style={{ wordBreak: "break-word" }}>{detail['shippingto']['address2'] ? `${detail['shippingto']['address2']}, ` : ""}</p>
                                                <p style={{ wordBreak: "break-word" }}>{detail['shippingto']['city'] ? `${detail['shippingto']['city']}, ` : ""}{detail['shippingto']['state'] ? detail['shippingto']['state'] : ""}</p>
                                                <p style={{ wordBreak: "break-word" }}>{detail['shippingto']['country'] ? `${detail['shippingto']['country']}, ` : ""}{detail['shippingto']['zipcode'] ? detail['shippingto']['zipcode'] : "" }</p>
                                            </div> : ''}
                                        </div>
                                    </div>
                                    {itemcount !== 0 ?
                                        <div style={{ overflowX: "auto" }}>
                                            <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                <thead>
                                                    <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                        <td style={{ paddingLeft: "2.5rem" }}>Items</td>
                                                        <td>SKU</td>
                                                        {!invoiceview ? <td>IRM</td> : null}
                                                        <td>Amount</td>
                                                        <td>Tax</td>
                                                        <td>Tax Amount</td>
                                                        <td>BP</td>
                                                        <td>BP Amount</td>
                                                        {applytaxonbp ? <td>BP Tax Amount</td> : ''}
                                                        <td style={{ paddingRight: "2.5rem" }}>Gross Amount</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        detail.items.map((item, index) => (
                                                            <tr>
                                                                <td style={{ paddingLeft: "2.5rem", width: "25%"  }}><a href={item.itemviewurl ? item.itemviewurl : `${buyerlinkurl}${this.state.updateInvoiceData.saleid}/item/${item.id}`} target="_blank">{item.title}</a></td>
                                                                <td style={{ wordBreak: "break-all"}}>{item.SKU ? item.SKU : "$ 0.00"}</td>
                                                                {!invoiceview ? <td style={{ whiteSpace: "nowrap" }}>{item.bidderirm ? capitalizeFirstLetter(item.bidderirm) : '- - -'}</td> : null }
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '$ 0.00'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.tax ? `${item.tax} %` : '$ 0.00'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.taxamount ? `$ ${parseFloat(item.taxamount).toFixed(2)}` : '$ 0.00'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremium ? `${item.buyerspremium} %` : '$ 0.00'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremiumamount ? `$ ${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '$ 0.00'}</td>
                                                                {applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>{item.taxonBPamount ? `$ ${parseFloat(item.taxonBPamount).toFixed(2)}` : '$ 0.00'}</td> : ''}
                                                                <td style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : '$ 0.00'}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                    <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                        <td></td>
                                                        <td></td>
                                                        {!invoiceview  ? <td></td> : null}
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(amountTotal).toFixed(2)}</td>
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(taxamountTotal).toFixed(2)}</td>
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(buyerspremiumamountTotal).toFixed(2)}</td>
                                                        {applytaxonbp  ? <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(taxonbuyerspremiumTotal).toFixed(2)}</td> : ''}
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(grossamountTotal).toFixed(2)}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div> :
                                        <div>
                                            {
                                                item?.selectedService?.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                    <thead>
                                                        <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                        <td style={{ textAlign: "left", paddingLeft: "2.5rem"  }}>Services</td>
                                                            <td style={{ textAlign: "left" }}>Description</td>
                                                            <td style={{ textAlign: "right", paddingRight: "2.5rem" }}>Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            item.selectedService.map((elem, index) => (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", width: "30%",paddingLeft: "2.5rem" }}>{elem.name}</td>
                                                                    <td style={{ textAlign: "left", width: "45%" }}>{elem.remark ? elem.remark : "- - -"}</td>
                                                                    <td style={{ textAlign: "right", paddingRight: "2.5rem" }}>{elem.amount ? `$ ${parseFloat(elem.amount).toFixed(2)}` : '$ 0.00'}</td>
                                                                </tr>
                                                            ))
                                                        }

                                                    </tbody>
                                                </Table>
                                            }
                                        </div>
                                    }
                                    
                                    <div className={`${this.state.windowWidth > 800 ? "d-flex flex-row" : ""}`} style={{ margin: "2% 5%" }}>
                                        
                                        <div className="" style={{ width: this.state.windowWidth > 800 ? "100%" :"100%" }}>
                                            {itemcount !== 0 ?
                                                <div>
                                                    <div className="serviceview">
                                                        {

                                                            selectedServeice.map((elem, index) => (
                                                                <Row className="">
                                                                    <Col className="text-left text-secondary" ><b>{elem.name}</b></Col>
                                                                    <Col >{elem.remark ? elem.remark : '- - -' }</Col>
                                                                    <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{elem.amount ? `$ ${parseFloat(elem.amount).toFixed(2)}` : '- - -'}</b></Col>
                                                                </Row>
                                                            ))
                                                        }
                                                    </div>
                                                    {/* <Row className="p-2">
                                                        <Col className="text-left text-secondary" ><b>Shipping Fee</b></Col>
                                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary"><b>{detail['shippinghandling'] ? `$ ${parseFloat(detail['shippinghandling']).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                    </Row>
                                                    <Row className="p-2">
                                                        <Col className="text-left text-secondary" ><b>Handling Fee</b></Col>
                                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary"><b>{detail['handling'] ? `$ ${parseFloat(detail['handling']).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                    </Row>
                                                    <Row className="p-2">
                                                        <Col className="text-left text-secondary" ><b>Additional Amount</b></Col>
                                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary"><b>{detail['additionalamount'] ? ` $ ${parseFloat(detail['additionalamount']).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                    </Row> */}
                                                </div> : ""}

                                            <div className="">
                                                {item.additionalnotes ? <p><b className="text-secondary" style={{ marginLeft: "0px" }}> Additional Notes </b>
                                                    <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{item.additionalnotes}</Tooltip>}>
                                                        <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                    <div className='viewonlyinprint'>
                                                        {item.additionalnotes}
                                                    </div>
                                                </p> : ''}
                                            </div>

                                            <div>

                                                <Row className="p-2" >
                                                    <Col className="text-left text-secondary amountLableStyle" ><b>Total Amount</b></Col>
                                                    <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary amountStyle"><b>{item.invoiceamount ? `$ ${parseFloat(item.invoiceamount).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                </Row>
                                                <Row className="p-2" >
                                                    <Col className="text-left text-secondary amountLableStyle" ><b>Payments Received</b></Col>
                                                    <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary amountStyle"><b>{item.invoiceamount ? `$ ${parseFloat(item.invoiceamount - item.pendingamount).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                </Row>
                                                <Row className="p-2" >
                                                    <Col className="text-left text-secondary amountLableStyle" ><b>Remaining Amount Due</b></Col>
                                                    <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-left text-secondary amountStyle"><b>{item.pendingamount ? `$ ${parseFloat(item.pendingamount).toFixed(2)}` : '$ 0.00'}</b></Col>
                                                </Row>
                                            </div>   
                                        </div></div>
                                    {invoicemessage ?
                                        <div className="px-5  message-warp" style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: invoicemessage }}></div>
                                        : ''}
                                </div>
                                {/* <div className={(this.state.InvoiceList.length - 1) === index ? '' : 'lastPage'}></div> */}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}